<mat-dialog-content class="modern-upload-dialog" [style.visibility]="mobilePickerOpen ? 'hidden' : 'visible'">
<input #fileInput id="fileInput" type="file" multiple
  (change)="onFileSelected($event)"
  (cancel)="onFilePickerCancelled()"
  [accept]="isAndroid ? 
    'image/jpeg,image/jpg,image/png,image/gif,image/webp,image/heic,image/heif,video/mp4,video/quicktime,video/x-msvideo,video/x-matroska' : 
    'image/jpeg,image/jpg,image/png,image/gif,image/webp,image/heic,image/heif,video/mp4,video/quicktime'"
  style="display:none" />

<input *ngIf="isAndroid || !isMobile" #folderInput id="folderInput" type="file"
  webkitdirectory (change)="onFolderSelected($event)"
  style="display:none" />

  <!-- Header -->
  <div class="upload-header" [class.upload-header--mobile-minimal]="isMobile && (selectedFiles.length === 0 || isFileLoading || isProcessing || uploadComplete)">
    <!-- Hidden while working. The handle is decorative (a bottom-sheet cue),
         but next to a "−" minimize button it read as a second, unexplained
         dash — testers could not tell which one did what. During upload the
         labelled "Browse Picaggo while it uploads" button in the card is the
         single minimize affordance, so both dashes go. -->
    <div *ngIf="isMobile && !isFileLoading && !isProcessing" class="mobile-drag-handle-bar"></div>

    <button class="close-btn" mat-button (click)="closeDialog(null)">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    <div class="header-content">
      <div class="icon-wrapper">
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="56" height="56" rx="28" fill="var(--color-accent-soft)" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M34 27C31.879 27 30.818 27 30.159 26.341C29.5 25.682 29.5 24.621 29.5 22.5C29.5 20.379 29.5 19.318 30.159 18.659C30.818 18 31.879 18 34 18C36.121 18 37.182 18 37.841 18.659C38.5 19.318 38.5 20.379 38.5 22.5C38.5 24.621 38.5 25.682 37.841 26.341C37.182 27 36.121 27 34 27ZM34.75 20.5C34.75 20.3011 34.671 20.1103 34.5303 19.9697C34.3897 19.829 34.1989 19.75 34 19.75C33.8011 19.75 33.6103 19.829 33.4697 19.9697C33.329 20.1103 33.25 20.3011 33.25 20.5V21.75H32C31.8011 21.75 31.6103 21.829 31.4697 21.9697C31.329 22.1103 31.25 22.3011 31.25 22.5C31.25 22.6989 31.329 22.8897 31.4697 23.0303C31.6103 23.171 31.8011 23.25 32 23.25H33.25V24.5C33.25 24.6989 33.329 24.8897 33.4697 25.0303C33.6103 25.171 33.8011 25.25 34 25.25C34.1989 25.25 34.3897 25.171 34.5303 25.0303C34.671 24.8897 34.75 24.6989 34.75 24.5V23.25H36C36.1989 23.25 36.3897 23.171 36.5303 23.0303C36.671 22.8897 36.75 22.6989 36.75 22.5C36.75 22.3011 36.671 22.1103 36.5303 21.9697C36.3897 21.829 36.1989 21.75 36 21.75H34.75V20.5Z"
            fill="var(--color-accent)" />
          <path
            d="M38.5002 28.698C38.4982 30.168 38.4872 31.416 38.4042 32.441C38.3072 33.631 38.1082 34.625 37.6642 35.45C37.4702 35.8116 37.2243 36.1428 36.9342 36.433C36.1012 37.266 35.0413 37.643 33.6973 37.823C32.3843 38 30.7003 38 28.5533 38H28.4472C26.2992 38 24.6172 38 23.3032 37.823C21.9602 37.643 20.8993 37.266 20.0672 36.433C19.3292 35.695 18.9472 34.777 18.7452 33.638C18.5452 32.518 18.5093 31.126 18.5023 29.397C18.5003 28.957 18.4996 28.4914 18.5002 28V27.946C18.5002 25.798 18.5003 24.116 18.6773 22.802C18.8573 21.459 19.2342 20.398 20.0672 19.566C20.9002 18.734 21.9602 18.356 23.3032 18.176C24.4712 18.019 25.9732 18.001 27.8022 17.999C27.9874 17.999 28.1649 18.0726 28.2958 18.2035C28.4267 18.3344 28.5002 18.5119 28.5002 18.697C28.5002 18.8821 28.4267 19.0597 28.2958 19.1906C28.1649 19.3215 27.9874 19.395 27.8022 19.395C25.9472 19.397 24.5682 19.413 23.4892 19.558C22.3002 19.718 21.5833 20.022 21.0533 20.552C20.5233 21.082 20.2202 21.8 20.0602 22.99C19.8972 24.2 19.8952 25.788 19.8952 28V28.784L20.8273 27.97C21.2358 27.6126 21.7649 27.4238 22.3074 27.4418C22.8499 27.4598 23.3653 27.6833 23.7492 28.067L27.7393 32.057C28.0488 32.3668 28.4577 32.5574 28.894 32.5952C29.3303 32.6331 29.7659 32.5158 30.1242 32.264L30.4023 32.069C30.919 31.7058 31.5438 31.5287 32.1743 31.5666C32.8048 31.6046 33.4038 31.8554 33.8732 32.278L36.5063 34.648C36.7712 34.091 36.9293 33.36 37.0133 32.328C37.0923 31.356 37.1033 30.176 37.1042 28.698C37.1042 28.5129 37.1778 28.3354 37.3087 28.2045C37.4396 28.0736 37.6171 28 37.8022 28C37.9874 28 38.1649 28.0736 38.2958 28.2045C38.4267 28.3354 38.5002 28.5129 38.5002 28.698Z"
            fill="var(--color-accent)" />
        </svg>
      </div>
      <!-- Desktop header title / Mobile title only when files are selected (not in initial or card states) -->
      <h2 class="upload-title" [class.upload-title--mobile-hidden]="isMobile && (selectedFiles.length === 0 || isFileLoading || isProcessing || uploadComplete)">
        {{ uploadComplete ? (stoppedCount > 0 ? uploadStoppedTitle : (uploadedFiles.length > 0 ? 'Upload Complete!' : 'Upload Failed')) :
        (isProcessing ? 'Processing...' : (isFileLoading ? (waitingForOtherUpload ? queuedTitle : (stopRequested ? stoppingTitle : 'Uploading...')) : (isMobile ? (isCheckingReadable ? 'Checking your photos' : 'Add Photos') : 'Add Photos & Videos'))) }}
      </h2>
      <p class="upload-subtitle" *ngIf="waitingForOtherUpload && !isMobile">{{ queuedNote }}</p>
      <p class="upload-subtitle"
        *ngIf="!isFileLoading && !uploadComplete && !isProcessing && selectedFiles.length === 0 && !isMobile">Select files from your
        device</p>

      <!-- <p class="upload-subtitle" *ngIf="isProcessing">Files uploaded successfully! Processing in the background...</p> -->
      <!-- Hidden while processing: a restored dialog has placeholder files with
           no size, so this read "10 files • 0 B". -->
      <p *ngIf="selectedFiles.length>0 && !isMobile && !isProcessing" style="margin-bottom:1px !important;">
        <span class="file-count">{{selectedFiles.length}} file{{selectedFiles.length !== 1 ? 's' : ''}} •
          {{getTotalSize()}}</span>
      </p>
      <!-- Network Speed Indicator (shown during upload) -->
      <!-- <div *ngIf="isFileLoading" class="network-speed-indicator" [class.slow-network]="isSlowNetwork">
        <div class="speed-info">
          <span class="speed-label">Upload Speed: </span>
          <span class="speed-value" [class.speed-slow]="isSlowNetwork">{{currentUploadSpeed}}</span>
          <span *ngIf="isSlowNetwork" class="slow-indicator">(Slow Network)</span>
        </div>
      </div> -->
      <p *ngIf="isCheckingDuplicates" class="checking-duplicates">
        <svg class="spinner" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="var(--color-border-light)" stroke-width="2" />
          <path d="M12 2C6.48 2 2 6.48 2 12" stroke="var(--color-accent)" stroke-width="2" stroke-linecap="round" />
        </svg>
        Checking duplicates...
      </p>
    </div>
  </div>

  <!-- Folder Selection - Desktop -->
  <div class="folder-selector" *ngIf="!uploadComplete && !isProcessing && subfolders.length > 0 && !isMobile">
    <label class="folder-label">Select Album</label>
    <select class="folder-field" [value]="selectedSubfolder" (change)="onSubfolderChange($event)">
      <option value="">No Folder</option>
      <option *ngFor="let subfolder of subfolders" [value]="subfolder.subfolder_id">
        {{ subfolder.subfolder_name }}
      </option>
    </select>
  </div>

  <!-- Folder Selection - Mobile pill style -->
  <div class="mobile-folder-selector" *ngIf="!uploadComplete && !isProcessing && subfolders.length > 0 && isMobile">
    <select class="mobile-folder-field" [value]="selectedSubfolder" (change)="onSubfolderChange($event)">
      <option value="">No Album</option>
      <option *ngFor="let subfolder of subfolders" [value]="subfolder.subfolder_id">
        {{ subfolder.subfolder_name }}
      </option>
    </select>
  </div>

  <!-- Drop Zone (shown when no files selected) - Desktop -->
  <div *ngIf="!uploadComplete && !isProcessing && selectedFiles.length === 0 && !isMobile" class="dropzone-container">
    <div class="modern-dropzone" [class.drag-over]="isDragOver" (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
      <div class="dropzone-content">
        <div class="upload-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7 18C4.23858 18 2 15.7614 2 13C2 10.4003 4.01099 8.26953 6.5 8.03009V8C6.5 5.23858 8.73858 3 11.5 3C13.7639 3 15.6747 4.52042 16.3149 6.59367C16.5341 6.54534 16.7644 6.5 17 6.5C19.4853 6.5 21.5 8.51472 21.5 11C21.5 13.4853 19.4853 15.5 17 15.5H16"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path d="M12 21L12 13M12 13L15 16M12 13L9 16" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p class="dropzone-text">Drop files or folders here</p>
        <p class="dropzone-hint">You can drag multiple folders at once, or click Browse Folder multiple times to add
          folders sequentially</p>
        <div class="dropzone-buttons">
          <button type="button" class="browse-files-btn" (click)="fileInput.click()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            Browse Files
          </button>
          <button type="button" class="browse-folder-btn" (click)="onAddFolderClick()"
            title="Click multiple times to select and add multiple folders (or drag multiple folders into dropzone at once)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V9C21 7.89543 20.1046 7 19 7H13L11 5H5C3.89543 5 3 5.89543 3 7Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M12 11V15M10 13H14" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            Browse Folder
          </button>
        </div>
        <!-- <p class="dropzone-subtext">Supports: Images and Videos</p> -->
        <p class="upload-limit" style="margin-top:12px; font-size:0.8rem; color:var(--color-text-secondary);" *ngIf="!isMobile">Note:
          Maximum
          upload per batch
          is <strong>1 GB</strong>. For larger uploads, split your selection into multiple batches.</p>
      </div>
    </div>
  </div>

  <!-- Mobile initial view (shown when no files selected) -->
  <div *ngIf="!uploadComplete && !isProcessing && selectedFiles.length === 0 && isMobile"
    class="mobile-initial-view">
    <!-- Hero graphic: place the illustrated party/phone image at src/assets/upload-hero.png -->
    <div class="mobile-hero-graphic">
      <img src="assets/upload_hero.png" alt="" class="mobile-hero-img"
        onerror="this.style.display='none'" />
    </div>
    <!-- Title & subtitle -->
    <h2 class="mobile-add-title">Add Photos</h2>
    <p class="mobile-add-subtitle">Your photos will be part of the beautiful event story</p>
    <!-- Action buttons row -->
    <div class="mobile-action-buttons">
      <div class="mobile-action-item" (click)="fileInput.click()">
        <div class="mobile-action-circle">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" stroke-width="1.5"/>
            <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
            <path d="M3 15L8 10L11 13L14 10L21 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span class="mobile-action-label">Choose from Gallery</span>
      </div>
      <!-- <div class="mobile-action-item" (click)="fileInput.click()">
        <div class="mobile-action-circle">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.5 4H9.5L7 7H4C2.9 7 2 7.9 2 9V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V9C22 7.9 21.1 7 20 7H17L14.5 4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12" cy="13" r="3.5" stroke="currentColor" stroke-width="1.5"/>
            <path d="M19 10H19.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <span class="mobile-action-label">Camera</span>
      </div> -->
      <!-- <div class="mobile-action-item" (click)="folderInput.click()">
        <div class="mobile-action-circle">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V9C21 7.89543 20.1046 7 19 7H13L11 5H5C3.89543 5 3 5.89543 3 7Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 11V15M10 13H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span class="mobile-action-label">Folders</span>
      </div> -->
    </div>
  </div>

  <!-- ✕ while photos are still being sent. Asked here rather than with a
       browser confirm(), which is unstyleable and which mobile can suppress. -->
  <div *ngIf="confirmingStop && isFileLoading" class="stop-confirm" role="alertdialog"
    aria-labelledby="stopConfirmTitle" aria-describedby="stopConfirmBody">
    <h3 id="stopConfirmTitle" class="stop-confirm__title">{{ stopTitle }}</h3>
    <p id="stopConfirmBody" class="stop-confirm__body">{{ stopBody }}</p>
    <div class="stop-confirm__actions">
      <button #stopKeepBtn type="button" class="btn-primary stop-confirm__btn" (click)="keepUploadingFromClose()">
        {{ stopKeepLabel }}
      </button>
      <button type="button" class="btn-secondary stop-confirm__btn stop-confirm__btn--stop" (click)="stopUpload()">
        {{ stopConfirmLabel }}
      </button>
    </div>
  </div>

  <!-- File List (shown when files are selected) -->
  <!-- Processing view.
       Deliberately a top-level block rather than another branch inside
       .file-list-container: that container is gated on selectedFiles.length,
       which is empty for the first moment of a restored dialog and produced a
       panel with a title and a Close button and nothing in between. This one
       needs no file list, so it can render the instant the dialog opens. -->
  <div *ngIf="isProcessing && !uploadComplete" class="processing-view">
    <div class="processing-view__ring" [class.is-indeterminate]="!processingTotal">
      <svg viewBox="0 0 120 120" class="processing-view__dial" aria-hidden="true">
        <circle class="processing-view__dial-track" cx="60" cy="60" r="52" />
        <circle class="processing-view__dial-fill" cx="60" cy="60" r="52"
          [style.stroke-dasharray]="dialCircumference"
          [style.stroke-dashoffset]="dialOffset" />
      </svg>
      <span class="processing-view__pct">{{ processingPercent }}<small>%</small></span>
    </div>

    <h3 class="processing-view__title">{{ isTransferring ? transferTitle : 'Getting your ' + albumLabel + ' ready' }}</h3>
    <p class="processing-view__count" *ngIf="isTransferring">{{ transferCountText }}</p>
    <p class="processing-view__count" *ngIf="!isTransferring && processingTotal">
      {{ processingCompleted }} of {{ processingTotal }} photos ready
    </p>
    <p class="processing-view__count" *ngIf="!isTransferring && !processingTotal">Just a moment…</p>

    <p class="processing-view__failed" *ngIf="processingFailed">
      {{ processingFailed }} couldn't be added
    </p>

    <p class="processing-view__note" *ngIf="isTransferring">{{ transferNote }}</p>
    <p class="processing-view__note" *ngIf="!isTransferring">
      Your photos are safely uploaded. You can close this — we'll finish in the background.
    </p>

    <!-- Processing runs on the server, so "in background" is true there. While
         photos are still being sent it is not: only browsing Picaggo is. -->
    <button type="button" class="processing-view__cta" (click)="minimizeDialog()"
      *ngIf="uploadBannerEnabled">
      {{ isTransferring ? browseWhileUploading : 'Continue in background' }}
    </button>
  </div>

  <div *ngIf="!uploadComplete && !isProcessing && selectedFiles.length > 0" class="file-list-container">

    <!-- Checking Storage Indicator -->
    <div *ngIf="isCheckingStorage" class="checking-storage">
      <svg class="spinner" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="var(--color-border-light)" stroke-width="2" />
        <path d="M12 2C6.48 2 2 6.48 2 12" stroke="var(--color-accent)" stroke-width="2" stroke-linecap="round" />
      </svg>
      <span>Checking storage availability...</span>
    </div>

    <!-- Storage Quota Exceeded Message -->
    <div *ngIf="storageQuotaExceeded" class="storage-quota-exceeded">
      <div class="quota-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
            fill="var(--color-alert-accent)" />
        </svg>
      </div>
      <div class="quota-content">
        <h4 class="quota-title">{{ isCollaboratorStorageBlock ? 'Event Gallery Temporarily Paused' : 'Storage Limit Exceeded' }}</h4>
        <p class="quota-message">{{storageQuotaMessage}}</p>
        <div class="quota-actions">
          <button *ngIf="!isCollaboratorStorageBlock" class="btn-upgrade" (click)="navigateToSubscription()">
            Upgrade Plan
          </button>
          <button *ngIf="isCollaboratorStorageBlock" class="btn-upgrade btn-upgrade--paused" disabled>
            Event Gallery Temporarily Paused
          </button>
        </div>
      </div>
    </div>


    <!-- Duplicate Warning Banner. Desktop only: on a phone the list of file
         names (IMG_20260926_191204.jpg…) is noise; mobile gets one line and
         an "Already added" tag on the tiles instead. -->
    <div *ngIf="showDuplicateWarning && !isMobile" class="duplicate-warning">
      <div class="warning-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64537 18.3024 1.55299 18.6453 1.55201 18.9945C1.55103 19.3437 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23675 20.5467 2.53773 20.7239C2.83871 20.9011 3.18082 20.9962 3.53 21H20.47C20.8192 20.9962 21.1613 20.9011 21.4623 20.7239C21.7633 20.5467 22.0126 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5317 3.56611 13.2807 3.32312 12.9812 3.15448C12.6817 2.98585 12.3437 2.89725 12 2.89725C11.6563 2.89725 11.3183 2.98585 11.0188 3.15448C10.7193 3.32312 10.4683 3.56611 10.29 3.86Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div class="warning-content">
        <h4 class="warning-title">Duplicate Files Detected</h4>
        <p class="warning-message">{{duplicateFiles.size}} file{{duplicateFiles.size !== 1 ? 's' : ''}} already
          exist{{duplicateFiles.size === 1 ? 's' : ''}} in this event. Duplicates will be skipped.</p>
        <div class="duplicate-list" *ngIf="duplicateFiles.size <= 5">
          <span *ngFor="let fileName of getDuplicateFileNames()" class="duplicate-file-name">{{fileName}}</span>
        </div>
      </div>
    </div>

    <!-- Desktop list header -->
    <div class="list-header" *ngIf="!isMobile">
      <div class="list-header-left">
        <h3>Selected Files</h3>
        <span class="file-count">{{selectedFiles.length}} file{{selectedFiles.length > 1 ? 's' : ''}} • {{getTotalSize()}}</span>
      </div>
      <div class="action-buttons-group">
        <button type="button" class="add-more-btn" (click)="onAddMoreClick()" [disabled]="isFileLoading || isProcessing"
          [attr.title]="(isFileLoading || isProcessing) ? 'Cannot add files while uploading/processing' : null">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Add Files
        </button>
        <button type="button" class="add-folder-btn" (click)="onAddFolderClick()"
          [disabled]="isFileLoading || isProcessing"
          [attr.title]="(isFileLoading || isProcessing) ? 'Cannot add folders while uploading/processing' : 'Click again to add another folder to the current selection'">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V9C21 7.89543 20.1046 7 19 7H13L11 5H5C3.89543 5 3 5.89543 3 7Z"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 11V15M10 13H14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Add Folder
        </button>
      </div>
    </div>

    <!-- Info message for multiple folder selection -->
    <!-- <div *ngIf="selectedFiles.length > 0 && !isFileLoading && !isProcessing" class="folder-info-message">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        style="margin-right: 8px; flex-shrink: 0;">
        <path
          d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span>Click "Add Folder" again to include more folders in this upload</span>
    </div> -->

    <!-- Connection notice: "waiting for your connection" while uploads are
         paused, otherwise the slow / stopped-responding line. One slot, so the
         two can never stack. -->
    <div *ngIf="networkNotice && isFileLoading" class="slow-network-message" role="status">
      <div class="warning-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64537 18.3024 1.55299 18.6453 1.55201 18.9945C1.55103 19.3437 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23675 20.5467 2.53773 20.7239C2.83871 20.9011 3.18082 20.9962 3.53 21H20.47C20.8192 20.9962 21.1613 20.9011 21.4623 20.7239C21.7633 20.5467 22.0126 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5317 3.56611 13.2807 3.32312 12.9812 3.15448C12.6817 2.98585 12.3437 2.89725 12 2.89725C11.6563 2.89725 11.3183 2.98585 11.0188 3.15448C10.7193 3.32312 10.4683 3.56611 10.29 3.86Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <span class="slow-network-text">{{networkNotice}}</span>
    </div>

    <!-- Photos the phone would not let us read, said once as soon as the first
         one turns up rather than left to fail one by one under the progress
         bar. Says what we know (the phone stopped sharing them), not a cause we
         have not measured. -->
    <div *ngIf="isFileLoading && unreadableFiles.size > 0" class="slow-network-message cloud-only-notice" role="status">
      <div class="warning-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 18a4.5 4.5 0 0 1-.9-8.91A6 6 0 0 1 17.7 8.1 4.5 4.5 0 0 1 17 18H7Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <span class="slow-network-text">{{unreadableInProgressText}}</span>
    </div>

    <!-- Uploading/Processing Status -->
    <!-- <div *ngIf="isFileLoading && !isProcessing" class="uploading-status-header">
      <div class="uploading-status-top">
        <span class="uploading-status-text">Uploading...</span>
       
      </div>
    </div>
    <div *ngIf="isProcessing" class="uploading-status-header">
      <span class="uploading-status-text">Getting your {{ albumLabel }} ready...</span>
    </div> -->

    <!-- Upload Progress Summary - Desktop -->
    <div *ngIf="(isFileLoading || isProcessing) && !isMobile" class="upload-progress-summary">
      <div class="progress-summary-row">
        <div class="progress-summary-info">
          <span class="progress-value">{{progressCount}} of {{selectedFiles.length}} Files </span>
        </div>
        <div class="progress-summary-eta" *ngIf="estimatedTime">
          <span class="eta-label">Estimated time: </span>
          <span class="eta-value">{{estimatedTime}}</span>
        </div>
      </div>
      <div class="overall-progress-bar">
        <!-- Byte-weighted, same as the mobile card: file-count progress reads 0%
             for the whole of a large first file. -->
        <div class="overall-progress-fill" [style.width.%]="overallUploadPercent">
        </div>
      </div>
    </div>

    <!-- Mobile Upload Progress Card -->
    <div *ngIf="(isFileLoading || isProcessing) && isMobile" class="mobile-upload-progress-card">
      <div class="mobile-upload-icon-circle mobile-upload-icon-circle--uploading">
        <svg width="32" height="32" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M34 27C31.879 27 30.818 27 30.159 26.341C29.5 25.682 29.5 24.621 29.5 22.5C29.5 20.379 29.5 19.318 30.159 18.659C30.818 18 31.879 18 34 18C36.121 18 37.182 18 37.841 18.659C38.5 19.318 38.5 20.379 38.5 22.5C38.5 24.621 38.5 25.682 37.841 26.341C37.182 27 36.121 27 34 27ZM34.75 20.5C34.75 20.3011 34.671 20.1103 34.5303 19.9697C34.3897 19.829 34.1989 19.75 34 19.75C33.8011 19.75 33.6103 19.829 33.4697 19.9697C33.329 20.1103 33.25 20.3011 33.25 20.5V21.75H32C31.8011 21.75 31.6103 21.829 31.4697 21.9697C31.329 22.1103 31.25 22.3011 31.25 22.5C31.25 22.6989 31.329 22.8897 31.4697 23.0303C31.6103 23.171 31.8011 23.25 32 23.25H33.25V24.5C33.25 24.6989 33.329 24.8897 33.4697 25.0303C33.6103 25.171 33.8011 25.25 34 25.25C34.1989 25.25 34.3897 25.171 34.5303 25.0303C34.671 24.8897 34.75 24.6989 34.75 24.5V23.25H36C36.1989 23.25 36.3897 23.171 36.5303 23.0303C36.671 22.8897 36.75 22.6989 36.75 22.5C36.75 22.3011 36.671 22.1103 36.5303 21.9697C36.3897 21.829 36.1989 21.75 36 21.75H34.75V20.5Z"
            fill="currentColor" />
          <path
            d="M38.5002 28.698C38.4982 30.168 38.4872 31.416 38.4042 32.441C38.3072 33.631 38.1082 34.625 37.6642 35.45C37.4702 35.8116 37.2243 36.1428 36.9342 36.433C36.1012 37.266 35.0413 37.643 33.6973 37.823C32.3843 38 30.7003 38 28.5533 38H28.4472C26.2992 38 24.6172 38 23.3032 37.823C21.9602 37.643 20.8993 37.266 20.0672 36.433C19.3292 35.695 18.9472 34.777 18.7452 33.638C18.5452 32.518 18.5093 31.126 18.5023 29.397C18.5003 28.957 18.4996 28.4914 18.5002 28V27.946C18.5002 25.798 18.5003 24.116 18.6773 22.802C18.8573 21.459 19.2342 20.398 20.0672 19.566C20.9002 18.734 21.9602 18.356 23.3032 18.176C24.4712 18.019 25.9732 18.001 27.8022 17.999C27.9874 17.999 28.1649 18.0726 28.2958 18.2035C28.4267 18.3344 28.5002 18.5119 28.5002 18.697C28.5002 18.8821 28.4267 19.0597 28.2958 19.1906C28.1649 19.3215 27.9874 19.395 27.8022 19.395C25.9472 19.397 24.5682 19.413 23.4892 19.558C22.3002 19.718 21.5833 20.022 21.0533 20.552C20.5233 21.082 20.2202 21.8 20.0602 22.99C19.8972 24.2 19.8952 25.788 19.8952 28V28.784L20.8273 27.97C21.2358 27.6126 21.7649 27.4238 22.3074 27.4418C22.8499 27.4598 23.3653 27.6833 23.7492 28.067L27.7393 32.057C28.0488 32.3668 28.4577 32.5574 28.894 32.5952C29.3303 32.6331 29.7659 32.5158 30.1242 32.264L30.4023 32.069C30.919 31.7058 31.5438 31.5287 32.1743 31.5666C32.8048 31.6046 33.4038 31.8554 33.8732 32.278L36.5063 34.648C36.7712 34.091 36.9293 33.36 37.0133 32.328C37.0923 31.356 37.1033 30.176 37.1042 28.698C37.1042 28.5129 37.1778 28.3354 37.3087 28.2045C37.4396 28.0736 37.6171 28 37.8022 28C37.9874 28 38.1649 28.0736 38.2958 28.2045C38.4267 28.3354 38.5002 28.5129 38.5002 28.698Z"
            fill="currentColor" />
        </svg>
      </div>
      <h3 class="mobile-upload-card-title">{{ isProcessing ? 'Getting your ' + albumLabel + ' ready' : (waitingForOtherUpload ? queuedTitle : (stopRequested ? stoppingTitle : 'Uploading your photos')) }}</h3>
      <!-- Queued behind another upload in this window: say so, rather than
           "0 of N · Calculating…", which reads as stuck. -->
      <p class="mobile-upload-card-subtitle" *ngIf="waitingForOtherUpload">{{ queuedNote }}</p>
      <!-- The old subtitle here repeated the picker's marketing line word for
           word and told the user nothing about their upload. On a slow link
           over a large video these two numbers are the only evidence anything
           is happening at all. -->
      <p class="mobile-upload-card-subtitle" *ngIf="!isProcessing && !stopRequested && !waitingForOtherUpload">
        {{ uploadedBytesLabel }}<ng-container *ngIf="uploadPaceLabel"> · {{ uploadPaceLabel }}</ng-container>
      </p>
      <!-- A stop can take a while to settle: a large file already on its way
           finishes first. Without this the card kept saying "Uploading". -->
      <p class="mobile-upload-card-subtitle" *ngIf="!isProcessing && stopRequested">{{ stoppingNote }}</p>
      <p class="mobile-upload-card-subtitle" *ngIf="isProcessing">
        Safe to close — we'll finish this in the background
      </p>
      <!-- Thumbnail strip -->
      <div class="mobile-thumb-strip" *ngIf="selectedFiles.length > 0">
        <div class="mobile-thumb-strip-inner">
          <ng-container *ngFor="let file of selectedFiles.slice(0, 3); let i = index">
            <div class="mobile-thumb-strip-item" [class.mobile-thumb-strip-item--last]="i === 2 && selectedFiles.length > 3">
              <img *ngIf="fileThumbnails[i] && !thumbnailError[i]" [src]="fileThumbnails[i]" alt=""
                (error)="thumbnailError[i] = true" style="width:100%;height:100%;object-fit:cover;border-radius:10px;">
              <div *ngIf="!fileThumbnails[i] || thumbnailError[i]" class="mobile-thumb-strip-placeholder"
                [style.background]="'hsl(' + ((i * 47 + 180) % 360) + ', 45%, 70%)'">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" style="opacity:0.5">
                  <rect x="3" y="3" width="18" height="18" rx="3" stroke="white" stroke-width="1.5"/>
                  <circle cx="8.5" cy="8.5" r="1.5" fill="white"/>
                  <path d="M3 16l5-5 4 4 3-3 6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div *ngIf="i === 2 && selectedFiles.length > 3" class="mobile-thumb-strip-overlay">
                +{{selectedFiles.length - 3}}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- Progress bar -->
      <div class="mobile-upload-progress-bar-wrap">
        <div class="mobile-upload-progress-bar-row">
          <!-- "Completed"/"uploaded" were saying what the number and the count
               already say. -->
          <span class="mobile-upload-progress-pct">{{ overallUploadPercent }}%</span>
          <span class="mobile-upload-progress-count">{{progressCount}} of {{selectedFiles.length}} files</span>
        </div>
        <!-- Striped while running, so a bar that is genuinely creeping along at
             1% a minute still reads as alive rather than hung. -->
        <div class="mobile-upload-progress-track">
          <div class="mobile-upload-progress-fill" [class.is-active]="isFileLoading || isProcessing"
            [style.width.%]="overallUploadPercent"></div>
        </div>
      </div>

      <!-- Inside the card, not under it. As a full-width outlined pill below the
           card it read as a second, competing card, and the explanatory line
           only repeated the label. The button belongs to the progress it acts
           on, so it lives in the same box, styled as the secondary action it
           is. What it does after minimising is shown by the banner itself. -->
      <button type="button" class="card-background-btn" *ngIf="isFileLoading && uploadBannerEnabled && !confirmingStop && !stopRequested && !waitingForOtherUpload"
        (click)="minimizeDialog()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        {{ browseWhileUploading }}
      </button>
    </div>

    <!-- Processing Message -->
    <!-- <div *ngIf="isProcessing" class="processing-message">
      <div class="processing-icon">
        <svg class="spinner" width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="var(--color-border-light)" stroke-width="3" />
          <path d="M12 2C6.48 2 2 6.48 2 12" stroke="var(--color-accent)" stroke-width="3" stroke-linecap="round" />
        </svg>
      </div>
      <h3>Files Uploaded Successfully!</h3>
      <p>Your files are being processed in the background. You can safely close this dialog.</p>

      <div class="processing-stats">
        <div class="stat-item">
          <span class="stat-label">Completed:</span>
          <span class="stat-value">{{ processingCompleted }} / {{ selectedFiles.length || (processingRemaining +
            processingCompleted + processingFailed) }}</span>
        </div>
        <div class="stat-item" *ngIf="processingFailed > 0">
          <span class="stat-label">Failed:</span>
          <span class="stat-value failed">{{ processingFailed }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Remaining:</span>
          <span class="stat-value">{{ processingRemaining }}</span>
        </div>
      </div>

      <p class="processing-note">Processing may take a few minutes. Your images will appear in the gallery once ready.
      </p>
      <button class="btn-minimize" (click)="minimizeDialog()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 13H5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        Minimize
      </button>
    </div> -->

    <!-- Minimize message during processing -->
    <div *ngIf="isProcessing" class="minimize-message-container">
      <p class="minimize-message">You can close the window, we can work in background</p>
    </div>

    <!-- Picking-time read check (mobile): progress while it runs -->
    <div *ngIf="!isProcessing && !isFileLoading && isMobile && isCheckingReadable" class="mobile-readcheck">
      <div class="mobile-readcheck-row">
        <svg class="mobile-readcheck-spin" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-opacity="0.15" stroke-width="2.5" />
          <path d="M12 3a9 9 0 0 1 9 9" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
        </svg>
        <span>{{ readableChecked.size }} of {{ selectedFiles.length }} checked</span>
      </div>
      <div class="mobile-readcheck-track">
        <div class="mobile-readcheck-fill"
          [style.width.%]="selectedFiles.length ? (readableChecked.size * 100 / selectedFiles.length) : 0"></div>
      </div>
    </div>

    <!-- Picking-time read check (mobile): photos the phone already won't share.
         Short on purpose — the how-to steps live on the result card, after
         the rest have uploaded, so nobody leaves mid-pick and loses it. -->
    <div *ngIf="!isProcessing && !isFileLoading && isMobile && !isCheckingReadable && precheckUnreadable.size > 0"
      class="mobile-cloud-panel mobile-cloud-panel--pre">
      <div class="mobile-cloud-panel-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 18C4.79086 18 3 16.2091 3 14C3 11.9013 4.58481 10.1698 6.62623 10.0143C6.94363 7.19409 9.34534 5 12.25 5C15.0788 5 17.4308 7.06759 17.8395 9.77335C19.7185 10.0745 21.15 11.7025 21.15 13.6667C21.15 15.8482 19.3846 17.6136 17.2031 17.6136"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 12V21M12 21L9 18M12 21L15 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div class="mobile-cloud-panel-text">
        <p class="mobile-cloud-panel-title">{{unreadablePickTitleText}}</p>
        <p class="mobile-cloud-panel-body">{{unreadablePickBodyText}}</p>
        <button type="button" class="mobile-cloud-panel-btn" (click)="retryUnreadable()" [disabled]="isRetryingUnreadable">
          <svg *ngIf="isRetryingUnreadable" class="mobile-readcheck-spin" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-opacity="0.15" stroke-width="2.5" />
            <path d="M12 3a9 9 0 0 1 9 9" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
          </svg>
          {{ isRetryingUnreadable ? 'Trying again…' : 'Try again' }}
        </button>
      </div>
    </div>

    <!-- Duplicates (mobile): one line, no file names; the tiles carry the tag -->
    <div *ngIf="!isProcessing && !isFileLoading && isMobile && duplicateFiles.size > 0" class="mobile-dup-line">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="8" y="8" width="12" height="12" rx="2.5" stroke="currentColor" stroke-width="1.8" />
        <path d="M16 8V6.5A2.5 2.5 0 0 0 13.5 4h-7A2.5 2.5 0 0 0 4 6.5v7A2.5 2.5 0 0 0 6.5 16H8" stroke="currentColor" stroke-width="1.8" />
      </svg>
      <span>{{duplicateFiles.size}} already in this {{ albumLabel }} · we’ll skip {{duplicateFiles.size === 1 ? 'it' : 'them'}}</span>
    </div>

    <!-- Mobile thumbnail grid (shown while selecting, not during upload/processing).
         Iterates indices, not files: tiles the upload will skip sort first so
         their tags stay visible when only nine of a large pick are shown. -->
    <div *ngIf="!isProcessing && !isFileLoading && isMobile" class="mobile-thumb-grid-card">
      <div class="mobile-thumb-grid">
        <ng-container *ngFor="let i of mobileGridIndices; let pos = index; trackBy: trackByFileIndex">
          <div class="mobile-thumb-grid-item" [class.mobile-thumb-grid-item--last]="pos === 8 && selectedFiles.length > 9"
            [ngClass]="'mobile-thumb-grid-item--' + tileState(selectedFiles[i])">
            <img *ngIf="fileThumbnails[i] && !thumbnailError[i]" [src]="fileThumbnails[i]" alt=""
              (error)="thumbnailError[i] = true" class="mobile-thumb-grid-img">
            <div *ngIf="!fileThumbnails[i] || thumbnailError[i]" class="mobile-thumb-grid-placeholder"
              [style.background]="'hsl(' + ((i * 47 + 180) % 360) + ', 45%, 70%)'">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="opacity:0.5">
                <rect x="3" y="3" width="18" height="18" rx="3" stroke="white" stroke-width="1.5"/>
                <circle cx="8.5" cy="8.5" r="1.5" fill="white"/>
                <path d="M3 16l5-5 4 4 3-3 6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <ng-container [ngSwitch]="tileState(selectedFiles[i])">
              <div *ngSwitchCase="'pending'" class="mobile-thumb-tile-spinner">
                <svg class="mobile-readcheck-spin" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="9" stroke="white" stroke-opacity="0.45" stroke-width="2.5" />
                  <path d="M12 3a9 9 0 0 1 9 9" stroke="white" stroke-width="2.5" stroke-linecap="round" />
                </svg>
              </div>
              <span *ngSwitchCase="'cloud'" class="mobile-thumb-tag">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M7 18C4.79 18 3 16.21 3 14c0-2.1 1.58-3.83 3.63-3.99C6.94 7.19 9.35 5 12.25 5c2.83 0 5.18 2.07 5.59 4.77 1.88.3 3.31 1.93 3.31 3.9 0 2.18-1.77 3.94-3.95 3.94H7z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
                </svg>
                Cloud
              </span>
              <span *ngSwitchCase="'dup'" class="mobile-thumb-tag">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Added
              </span>
            </ng-container>
            <div *ngIf="pos === 8 && selectedFiles.length > 9" class="mobile-thumb-grid-overlay">
              +{{selectedFiles.length - 9}}
            </div>
          </div>
        </ng-container>
      </div>
      <button class="mobile-thumb-add-more" (click)="onAddMoreClick()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Add More</span>
      </button>
    </div>

    <!-- Desktop Virtual Scroll Viewport -->
    <!-- itemSize must equal .file-item's fixed height (82px) plus the content
         wrapper's 8px gap. See the .file-item rule for why a mismatch silently
         truncates the list. -->
    <cdk-virtual-scroll-viewport *ngIf="!isProcessing && !isMobile" [itemSize]="90" class="files-wrapper-virtual"
      [style.height.px]="filesViewportHeight">
      <div *cdkVirtualFor="let file of selectedFiles; let i = index; trackBy: trackByIndex" class="file-item"
        [class.uploading]="uploadProgressMap.has(file.name) && !uploadedCheck[i]" [class.completed]="uploadedCheck[i]"
        [class.duplicate]="duplicateFiles.has(file.name)">

        <div class="file-thumbnail">
          <img *ngIf="fileThumbnails[i] && !thumbnailError[i]" [src]="fileThumbnails[i]" alt=""
            (error)="thumbnailError[i] = true">
          <div *ngIf="(!fileThumbnails[i] || thumbnailError[i]) && file.type.startsWith('video/')"
            class="thumbnail-placeholder video-thumb">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 10L18.5768 8.45392C19.3699 7.97803 19.7665 7.74009 20.0928 7.77051C20.3773 7.79703 20.6369 7.944 20.806 8.17433C21 8.43848 21 8.90095 21 9.8259V14.1741C21 15.099 21 15.5615 20.806 15.8257C20.6369 16.056 20.3773 16.203 20.0928 16.2295C19.7665 16.2599 19.3699 16.022 18.5768 15.5461L16 14M6.8 18H12.2C13.8802 18 14.7202 18 15.362 17.673C15.9265 17.3854 16.3854 16.9265 16.673 16.362C17 15.7202 17 14.8802 17 13.2V10.8C17 9.11984 17 8.27976 16.673 7.63803C16.3854 7.07354 15.9265 6.6146 15.362 6.32698C14.7202 6 13.8802 6 12.2 6H6.8C5.11984 6 4.27976 6 3.63803 6.32698C3.07354 6.6146 2.6146 7.07354 2.32698 7.63803C2 8.27976 2 9.11984 2 10.8V13.2C2 14.8802 2 15.7202 2.32698 16.362C2.6146 16.9265 3.07354 17.3854 3.63803 17.673C4.27976 18 5.11984 18 6.8 18Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div *ngIf="(!fileThumbnails[i] || thumbnailError[i]) && !file.type.startsWith('video/')"
            class="thumbnail-placeholder">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 16L8.586 11.414C9.367 10.633 10.633 10.633 11.414 11.414L16 16M14 14L15.586 12.414C16.367 11.633 17.633 11.633 18.414 12.414L20 14M14 8H14.01M6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>

        <div class="file-info">
          <div class="file-name">
            {{file.name}}
            <span *ngIf="duplicateFiles.has(file.name)" class="duplicate-badge">Duplicate</span>
            <!-- Skipped by the upload: say so here, not only on the button's count. -->
            <span *ngIf="!duplicateFiles.has(file.name) && precheckUnreadable.has(file.name)" class="duplicate-badge">{{ unreadableTag }}</span>
          </div>
          <div class="file-meta">
            <span class="file-size">{{getFileSize(file.size)}}</span>
          </div>
          <div *ngIf="uploadProgressMap.has(file.name) && !uploadedCheck[i]" class="progress-bar-wrapper">
            <div class="progress-bar" [style.width.%]="uploadProgressMap.get(file.name)?.progress_percentage || 0"></div>
            <span class="progress-text">{{uploadProgressMap.get(file.name)?.progress_percentage || 0}}%</span>
          </div>
        </div>

        <div class="status-badge-wrapper">
          <span *ngIf="uploadProgressMap.has(file.name) && !uploadedCheck[i]" class="status-badge uploading-badge">Uploading</span>
          <span *ngIf="uploadedCheck[i]" class="status-badge completed-badge">Completed</span>
        </div>

        <button *ngIf="!isFileLoading && !uploadedCheck[i] && !uploadComplete" class="remove-file-btn" (click)="removeFile(i)">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  <!-- Upload Complete Summary -->
  <div *ngIf="uploadComplete" class="upload-complete-container">
    <h3 *ngIf="!isMobile" class="upload-review-title">Upload review</h3>

    <!-- Mobile Result Card -->
    <div *ngIf="isMobile" class="mobile-result-card">
      <div class="mobile-result-icon-circle mobile-result-icon-circle--success" *ngIf="failedFiles.length === 0 && uploadedFiles.length > 0">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <h3 class="mobile-result-title">{{ mobileResultTitle }}</h3>
      <p class="mobile-result-subtitle" *ngIf="mobileResultSubtitle">{{ mobileResultSubtitle }}</p>

      <!-- Uploaded thumbnails: up to 2, plus a running "+N" tile for the rest -->
      <div class="mobile-result-thumbs" *ngIf="uploadedFiles.length > 0">
        <div class="mobile-result-thumb" *ngFor="let file of uploadedFiles.slice(0, 2)">
          <!-- By name, not by object identity. indexOf() compares references, and
               the File in uploadedFiles is not always the one that was picked —
               anything that re-wraps it mid-upload makes indexOf return -1, and
               fileThumbnails[-1] is undefined, so the tile rendered blank with
               no error to notice. getFileThumbnail() already looked up by name
               for the duplicates list; it just was not used here. -->
          <img *ngIf="getFileThumbnail(file.name) && !resultThumbError.has(file.name)"
            [src]="getFileThumbnail(file.name)" alt=""
            (error)="resultThumbError.add(file.name)">
          <div *ngIf="!getFileThumbnail(file.name) || resultThumbError.has(file.name)"
            class="mobile-result-thumb-placeholder">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 16L8.586 11.414C9.367 10.633 10.633 10.633 11.414 11.414L16 16M14 14L15.586 12.414C16.367 11.633 17.633 11.633 18.414 12.414L20 14M14 8H14.01M6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <div class="mobile-result-thumb mobile-result-thumb--overflow">
          <span>+{{ uploadedThumbOverflowCount }}</span>
        </div>
      </div>

      <!-- Cloud-only photos: the one kind of failure a user can resolve
           themselves. Counts both the ones the picking-time check held back
           and any that still failed at upload. The how-to lives here, after
           the rest are safely up, not before the upload. -->
      <div class="mobile-cloud-panel" *ngIf="cloudLeftCount > 0">
        <div class="mobile-cloud-panel-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 18C4.79086 18 3 16.2091 3 14C3 11.9013 4.58481 10.1698 6.62623 10.0143C6.94363 7.19409 9.34534 5 12.25 5C15.0788 5 17.4308 7.06759 17.8395 9.77335C19.7185 10.0745 21.15 11.7025 21.15 13.6667C21.15 15.8482 19.3846 17.6136 17.2031 17.6136"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 12V21M12 21L9 18M12 21L15 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div class="mobile-cloud-panel-text">
          <p class="mobile-cloud-panel-title">{{unreadableResultTitleText}}</p>
          <!-- In order of effort. Picking again is the cheap thing to try and
               fixes the case where the phone simply took access back; the
               Google Photos steps are for a photo that was never on the phone. -->
          <ol class="mobile-cloud-panel-steps">
            <li>Tap <b>Add photos</b> and pick {{cloudLeftCount === 1 ? 'it' : 'them'}} again</li>
            <li>Still not working? Open Google Photos, open each photo, tap <b>⋮</b> then <b>Download</b></li>
            <li>Then add {{cloudLeftCount === 1 ? 'it' : 'them'}} here again</li>
          </ol>
          <a class="mobile-cloud-panel-btn" href="https://photos.google.com" target="_blank" rel="noopener"
            (click)="onOpenGooglePhotos()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M14 4h6v6M20 4l-9 9M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Open Google Photos
          </a>
        </div>
      </div>

      <!-- Every other non-retryable failure kind, plain notice rows -->
      <div class="mobile-result-notice mobile-result-notice--warning" *ngFor="let group of otherNonRetryableFailureGroups">
        <span>{{group.message}}</span>
      </div>

      <!-- Retryable (non-cloud) failures: grouped by cause, because "Retry" is
           only a good idea once you know why it didn't go the first time. -->
      <div class="mobile-result-notice mobile-result-notice--error" *ngFor="let group of retryableFailureGroups">
        <span>{{group.message}}</span>
      </div>

      <!-- Duplicates -->
      <div class="mobile-result-notice mobile-result-notice--warning" *ngIf="skippedDuplicates > 0">
        <span>{{skippedDuplicates}} duplicate{{skippedDuplicates !== 1 ? 's' : ''}} skipped</span>
      </div>

      <!-- One hero action per screen. Cloud-only photos have none: they need
           a trip to Google Photos first, which the panel above covers. -->
      <button class="mobile-result-hero-btn" *ngIf="retryableFailedFiles.length > 0"
        (click)="retryFailedUploads()" [disabled]="isRetryingFailed">
        {{isRetryingFailed ? 'Retrying…' : 'Retry ' + retryableFailedFiles.length + ' failed upload' + (retryableFailedFiles.length !== 1 ? 's' : '')}}
      </button>

      <!-- Done: the plain text link when a hero already covers the main action,
           promoted to the main (ink) button when there's nothing else to do. -->
      <button class="mobile-result-done-btn"
        [class.mobile-result-done-btn--main]="retryableFailedFiles.length === 0"
        (click)="closeDialog(selectedFiles)">Done</button>

      <!-- Guests only, once per event (GuestHostPromptService). A quiet line,
           not a button: Done stays the main action. -->
      <button type="button" class="mobile-result-host-line" *ngIf="showHostLine"
        (click)="onStartOwnEvent()">
        Planning your own event? <span class="mobile-result-host-line__cta">Start one free</span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <!-- Desktop Upload Review Sections -->
    <div *ngIf="!isMobile">
      <!-- Upload Review Sections -->
      <div class="review-section" *ngIf="uploadedFiles.length > 0">
        <div class="review-section-header" (click)="showSuccessSection = !showSuccessSection">
          <span class="section-title success-text">Successfully uploaded</span>
          <div class="section-info">
            <span class="file-count">{{uploadedFiles.length}} Files</span>
            <span class="file-size">{{getUploadedTotalSize()}}</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              [class.rotated]="showSuccessSection">
              <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <div class="review-section-content" *ngIf="showSuccessSection">
          <div class="review-file-item" *ngFor="let file of uploadedFiles; let i = index">
            <div class="file-thumbnail-small">
              <img *ngIf="getFileThumbnail(file.name) && !resultThumbError.has(file.name)"
                [src]="getFileThumbnail(file.name)" alt=""
                (error)="resultThumbError.add(file.name)">
              <div *ngIf="!getFileThumbnail(file.name) || resultThumbError.has(file.name)"
                class="thumbnail-placeholder-small">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4 16L8.586 11.414C9.367 10.633 10.633 10.633 11.414 11.414L16 16M14 14L15.586 12.414C16.367 11.633 17.633 11.633 18.414 12.414L20 14M14 8H14.01M6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <div class="file-details">
              <span class="file-name-small">{{file.name}}</span>
              <span class="file-size-small">{{getFileSize(file.size)}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Failed Section -->
      <div class="review-section" *ngIf="failedFiles.length > 0 || precheckLeftOut.length > 0">
        <div class="review-section-header" (click)="showFailedSection = !showFailedSection">
          <!-- After a stop that is all that is missing, it is not a failure. -->
          <span class="section-title" [class.failed-text]="!missedOnlyByStop">{{ missedOnlyByStop ? stoppedSectionTitle : 'Failed Uploads' }}</span>
          <div class="section-info">
            <span class="file-count">{{failedFiles.length + precheckLeftOut.length}} Files</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              [class.rotated]="showFailedSection">
              <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <div class="review-section-content" *ngIf="showFailedSection">
          <!-- Photos the computer wouldn't let us read: the one kind a user can
               often resolve themselves -->
          <div class="review-cloud-panel" *ngIf="cloudLeftCount > 0">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 18C4.79086 18 3 16.2091 3 14C3 11.9013 4.58481 10.1698 6.62623 10.0143C6.94363 7.19409 9.34534 5 12.25 5C15.0788 5 17.4308 7.06759 17.8395 9.77335C19.7185 10.0745 21.15 11.7025 21.15 13.6667C21.15 15.8482 19.3846 17.6136 17.2031 17.6136"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M12 12V21M12 21L9 18M12 21L15 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div>
              <p class="review-cloud-panel-title">{{cloudLeftCount}} photo{{cloudLeftCount !== 1 ? 's' : ''}} couldn't be read from your computer</p>
              <p class="review-cloud-panel-body">Add {{cloudLeftCount === 1 ? 'it' : 'them'}} again. If that doesn't work, download {{cloudLeftCount === 1 ? 'it' : 'them'}} from Google Photos first.</p>
            </div>
          </div>

          <!-- Every other non-retryable failure kind -->
          <ul class="review-notice-list" *ngIf="otherNonRetryableFailureGroups.length > 0 || retryableFailureGroups.length > 0">
            <li *ngFor="let group of otherNonRetryableFailureGroups">{{group.message}}</li>
            <li *ngFor="let group of retryableFailureGroups">{{group.message}}</li>
          </ul>

          <div class="review-actions">
            <!-- One hero action per screen -->
            <button class="btn-review-hero" *ngIf="cloudLeftCount > 0" (click)="onAddMoreClick()">
              Add {{cloudLeftCount}} photo{{cloudLeftCount !== 1 ? 's' : ''}} again
            </button>
            <button class="btn-review-hero" *ngIf="cloudLeftCount === 0 && retryableFailedFiles.length > 0"
              (click)="retryFailedUploads()" [disabled]="isRetryingFailed">
              <svg *ngIf="!isRetryingFailed" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4V10H7M23 20V14H17M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span class="spinner-small" *ngIf="isRetryingFailed"
                style="display: inline-block; width: 14px; height: 14px; border: 2px solid rgba(255,255,255,0.3); border-top-color: white; border-radius: 50%; animation: spin 0.6s linear infinite;"></span>
              {{isRetryingFailed ? 'Retrying...' : 'Retry ' + retryableFailedFiles.length + ' failed upload' + (retryableFailedFiles.length !== 1 ? 's' : '')}}
            </button>
            <!-- Cloud-only already claimed the hero, so a co-occurring retryable
                 failure (rare) gets the secondary pill instead of a second hero. -->
            <button class="btn-review-secondary" *ngIf="cloudLeftCount > 0 && retryableFailedFiles.length > 0"
              (click)="retryFailedUploads()" [disabled]="isRetryingFailed">
              {{isRetryingFailed ? 'Retrying...' : 'Retry ' + retryableFailedFiles.length + ' other failed upload' + (retryableFailedFiles.length !== 1 ? 's' : '')}}
            </button>
            <button class="btn-review-secondary" (click)="downloadFailedFilesList()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Download list
            </button>
          </div>

          <div class="review-file-item" *ngFor="let failedItem of failedFiles; let i = index">
            <div class="file-thumbnail-small">
              <div class="thumbnail-placeholder-small thumbnail-placeholder-small--error">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64537 18.3024 1.55299 18.6453 1.55201 18.9945C1.55103 19.3437 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23675 20.5467 2.53773 20.7239C2.83871 20.9011 3.18082 20.9962 3.53 21H20.47C20.8192 20.9962 21.1613 20.9011 21.4623 20.7239C21.7633 20.5467 22.0126 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5317 3.56611 13.2807 3.32312 12.9812 3.15448C12.6817 2.98585 12.3437 2.89725 12 2.89725C11.6563 2.89725 11.3183 2.98585 11.0188 3.15448C10.7193 3.32312 10.4683 3.56611 10.29 3.86Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <div class="file-details">
              <span class="file-name-small">{{failedItem.file.name}}</span>
              <span class="file-size-small">{{getFileSize(failedItem.file.size)}}</span>
              <!-- The reason in a few words. The error text itself stays in the
                   log and the downloadable list, where it's useful to us and
                   noise to everyone else. -->
              <span class="file-error-small">{{reasonFor(failedItem)}}</span>
            </div>
          </div>

          <!-- Set aside at pick time: never attempted, so not in failedFiles. -->
          <div class="review-file-item" *ngFor="let leftOut of precheckLeftOut">
            <div class="file-thumbnail-small">
              <div class="thumbnail-placeholder-small thumbnail-placeholder-small--error">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64537 18.3024 1.55299 18.6453 1.55201 18.9945C1.55103 19.3437 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23675 20.5467 2.53773 20.7239C2.83871 20.9011 3.18082 20.9962 3.53 21H20.47C20.8192 20.9962 21.1613 20.9011 21.4623 20.7239C21.7633 20.5467 22.0126 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5317 3.56611 13.2807 3.32312 12.9812 3.15448C12.6817 2.98585 12.3437 2.89725 12 2.89725C11.6563 2.89725 11.3183 2.98585 11.0188 3.15448C10.7193 3.32312 10.4683 3.56611 10.29 3.86Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <div class="file-details">
              <span class="file-name-small">{{leftOut.name}}</span>
              <span class="file-size-small">{{getFileSize(leftOut.size)}}</span>
              <span class="file-error-small">{{leftOutReason}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Duplicates Section -->
      <div class="review-section" *ngIf="skippedDuplicates > 0">
        <div class="review-section-header" (click)="showDuplicatesSection = !showDuplicatesSection">
          <span class="section-title duplicates-text">Duplicates</span>
          <div class="section-info">
            <span class="file-count">{{skippedDuplicates}} Files</span>
            <span class="file-size">{{getTotalSizeForDuplicates()}}</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              [class.rotated]="showDuplicatesSection">
              <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <div class="review-section-content" *ngIf="showDuplicatesSection">
          <div class="review-file-item" *ngFor="let fileName of getDuplicateFileNames(); let i = index">
            <div class="file-thumbnail-small">
              <ng-container *ngIf="getFileThumbnail(fileName); else noThumb">
                <img [src]="getFileThumbnail(fileName)" class="thumbnail-img-small" alt="thumbnail" />
              </ng-container>
              <ng-template #noThumb>
                <div class="thumbnail-placeholder-small">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4 16L8.586 11.414C9.367 10.633 10.633 10.633 11.414 11.414L16 16M14 14L15.586 12.414C16.367 11.633 17.633 11.633 18.414 12.414L20 14M14 8H14.01M6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </ng-template>
            </div>
            <div class="file-details">
              <span class="file-name-small">{{fileName}}</span>
              <span class="file-size-small">{{getDuplicateFileSize(fileName)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Desktop Review Sections -->

    <div *ngIf="isRefreshingImages" class="refreshing-indicator">
      <svg class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="var(--color-border-light)" stroke-width="3" />
        <path d="M12 2C6.48 2 2 6.48 2 12" stroke="var(--color-accent)" stroke-width="3" stroke-linecap="round" />
      </svg>
      <span>Refreshing gallery...</span>
    </div>
  </div>
</mat-dialog-content>

<!-- Nothing here is actionable mid-upload on mobile, and an empty bar is still
     a bar: the whole footer goes while the progress card is on screen. The
     header ✕ remains; mid-upload it asks whether to keep going or stop. -->
<!-- The processing view owns its own actions, so the footer would only add a
     second, differently-worded way to do the same thing. -->
<mat-dialog-actions class="dialog-actions" *ngIf="!(isMobile && isFileLoading) && !(isProcessing && !uploadComplete)"
  [class.dialog-actions--mobile-files]="isMobile && selectedFiles.length > 0 && !uploadComplete" [style.visibility]="mobilePickerOpen ? 'hidden' : 'visible'"
  [class.dialog-actions--guest-name]="showGuestNameField">

  <!-- Quick-join guests were named guest-MMDD-HHmmss; this is where they get
       to say who they are. Required for now: Upload stays disabled until it
       has a name (guestNameMissing). -->
  <div *ngIf="showGuestNameField" class="guest-name-field">
    <label for="guestNameInput" class="guest-name-field__label">Your name</label>
    <input id="guestNameInput" class="guest-name-field__input" type="text" autocomplete="name"
      maxlength="60" required aria-required="true" placeholder="So the host knows these are from you"
      [value]="guestNameDraft" (input)="guestNameDraft = $any($event.target).value"
      (keydown.enter)="$any($event.target).blur()">
  </div>

  <!-- Mobile: file count summary above upload button (hidden while uploading - card shows info) -->
  <p *ngIf="isMobile && selectedFiles.length > 0 && !uploadComplete && !isProcessing && !isFileLoading" class="mobile-file-count-summary">
    <ng-container *ngIf="!hasSkippedFiles || isCheckingReadable">{{selectedFiles.length}} file{{selectedFiles.length !== 1 ? 's' : ''}} · {{getTotalSize()}}</ng-container>
    <ng-container *ngIf="hasSkippedFiles && !isCheckingReadable">{{readyCount}} of {{selectedFiles.length}} photo{{selectedFiles.length !== 1 ? 's' : ''}} ready · {{readySizeLabel}}</ng-container>
  </p>

  <!-- Sets the expectation before the wait starts, rather than after: someone
       who knows they will not be trapped here is far less likely to close the
       tab mid-upload. -->
  <p *ngIf="selectedFiles.length > 0 && !uploadComplete && !isProcessing && !isFileLoading && uploadBannerEnabled && (readyCount > 0 || isCheckingReadable)"
    class="preupload-hint">
    {{keepOpenHint}}
  </p>

  <!-- Continue in background: desktop-only, sits at the footer's left edge
       (margin-right: auto in .footer-continue-btn) while Cancel/"Uploading..."
       stays on the right — a real action next to the disabled one, instead of
       living inside the gradient progress card. -->
  <button *ngIf="isFileLoading && !isMobile && uploadBannerEnabled && !confirmingStop && !stopRequested && !waitingForOtherUpload" type="button"
    class="footer-continue-btn" (click)="minimizeDialog()">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    {{ browseWhileUploading }}
  </button>

  <!-- Desktop cancel / mobile close only while processing. It used to render on
       mobile mid-upload too, as a disabled button reading "Uploading…" directly
       under a card already headed "Uploading your photos". -->
  <button *ngIf="!uploadComplete && (!isMobile || isFileLoading || isProcessing)"
    class="btn-secondary" type="button" [disabled]="isFileLoading && !waitingForOtherUpload" (click)="closeDialog(null)">
    {{isFileLoading && !waitingForOtherUpload ? (stopRequested ? stoppingTitle : 'Uploading...') : (isProcessing ? 'Close' : 'Cancel')}}
  </button>

  <!-- Hidden once the upload starts: a disabled "Upload" under a live progress
       card invites a tap that can do nothing. -->
  <button *ngIf="!uploadComplete && selectedFiles.length > 0 && !isProcessing && !isFileLoading && (readyCount > 0 || isCheckingReadable)" class="btn-primary btn-primary--hero"
    [class.btn-primary--mobile-full]="isMobile"
    [disabled]="storageQuotaExceeded || isCheckingStorage || isCheckingReadable || guestNameMissing" (click)="uploadImages()" type="button">
    {{ uploadButtonLabel }}
  </button>

  <!-- Nothing in the pick can be sent (all cloud-only or already added):
       no hero, just a way to start over. -->
  <button *ngIf="!uploadComplete && selectedFiles.length > 0 && !isProcessing && !isFileLoading && readyCount === 0 && !isCheckingReadable"
    class="btn-primary" [class.btn-primary--mobile-full]="isMobile" (click)="chooseOtherPhotos()" type="button">
    Choose other photos
  </button>

  <!-- Desktop only. The mobile result card carries its own Done, and promotes
       it to the ink main button when there is no retry hero above it — so on a
       phone this footer button was a second Done directly under the first. -->
  <button *ngIf="uploadComplete && !isMobile" class="btn-primary"
    (click)="closeDialog(selectedFiles)">
    Done
  </button>
</mat-dialog-actions>